var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"alert"},[_c('strong',[_c('a',{staticClass:"float-right crsr-pointer ml-2",on:{"click":function($event){return _vm.$emit('cleared')}}},[_vm._v("x")])]),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }